import React, { useContext } from 'react'
import { Stack } from '@hub/stack'
import { Text } from '@hub/text'
import { LinkContext } from '../../../context'
import { MegaMenuFeature } from '../types'
import { CloudinaryImage } from '../../cloudinary-image'

export const MegaMenuFeaturedItem: React.FC<{ feature: MegaMenuFeature }> = ({
  feature,
}) => {
  const Link = useContext(LinkContext)
  return (
    <Stack
      sx={{
        width: 'size-xl',
        maxHeight: 'size-full',
        display: ['none', null, null, 'initial'],
      }}
      gap="spacing-sm"
      shouldWrapChildren={false}
    >
      {feature.image && (
        <CloudinaryImage
          ratio="1"
          imageSetOrImage={{
            type: 'SQUARE',
            url: feature.image.src,
            alt: feature.image.description,
          }}
        />
      )}
      <Stack shouldWrapChildren={false} gap="spacing-sm">
        <Stack shouldWrapChildren={false}>
          {feature.title && (
            <Text tone="strong" lineHeight="base">
              {feature.title}
            </Text>
          )}
          {feature.body && <Text lineHeight="base">{feature.body}</Text>}
        </Stack>
        {feature.link && (
          <Text
            as={props => <Link {...props} to={feature?.link?.url} />}
            lineHeight="base"
            sx={{ textDecoration: 'underline' }}
          >
            {feature.link.label}
          </Text>
        )}
      </Stack>
    </Stack>
  )
}
